import { Component } from '@angular/core';
import { MdcService } from 'src/app/shared/mdc/mdc.service';

@Component({
  selector: 'app-step-section-vii',
  templateUrl: './step-section-vii.component.html',
})
export class StepSectionVIIIComponent {
  constructor(public mdcService: MdcService) { }
}
